<template>
  <v-dialog
    v-model="dialog"
    persistent
    :max-width="promotionDemotion ==='probation'?800:400"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        x-small
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Position"
      text="Update position"
      class="mb-0"
      :loading="loading"
    >
      <form v-if="dialog && !loading">
        <v-container>
          <v-row>
            <v-col :cols="promotionDemotion ==='probation'?6:12">
              <v-row>
                <v-col
                  cols="12"
                  class="pb-0"
                >
                  <v-autocomplete
                    v-model="localPosition.id"
                    v-validate="'required'"
                    :items="positions"
                    :error-messages="errors.collect('id')"    
                    data-vv-name="id"
                    data-vv-as="position"
                    label="Position"
                    item-text="label"
                    item-value="id"
                    outlined
                  />
                </v-col>

                <v-col
                  cols="12"
                  class="pb-4"
                >
                  <helper-file-input
                    v-model="file"
                    :max-size-in-mb="10"
                    :max-number="1"
                    data-vv-name="files"
                    field-name="files"
                    accept-type=".pdf"
                    extension="ext:pdf"     
                  >
                    <div
                      slot="activator"
                      class="mb-2"
                    >
                      <v-row>
                        <v-col>
                          <v-btn                
                            :disabled="progressing"
                            class="mx-2"
                          >
                            Add file
                          </v-btn>
                          <span>
                            {{ file ? '' : 'No file chosen (.pdf only)' }}
                          </span>
                        </v-col>
                        <v-col
                          v-if="file"
                          cols="10"
                          class="pl-4"
                        >
                          <div
                            v-for="(selectedFile) in file.selectedFiles"
                            :key="selectedFile.name"
                            class="font-weight-bold"
                          >
                            {{ selectedFile.name }}
                          </div>
                        </v-col>
                      </v-row>
                    </div>
                  </helper-file-input>
                  <span class="red--text text--lighten-1">{{ errors.first('files') }}</span>
                </v-col>

                <v-col
                  v-if="promotionDemotion === 'promotion' 
                    || promotionDemotion === 'demotion' 
                    || promotionDemotion === 'change_of_position' 
                    || promotionDemotion === 'change_of_company' 
                    || promotionDemotion === 'others'"
                  cols="12"
                  class="pb-0"
                >
                  <v-menu
                    v-model="effectiveDateMenu"
                    :close-on-content-click="false"
                    :nudge-right="20"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="effectiveDateDisplay"
                        v-validate="'required'"
                        label="Effective Date"
                        :error-messages="errors.collect('effectiveDateDisplay')"
                        data-vv-name="effectiveDateDisplay"
                        data-vv-as="effective date"  
                        readonly
                        class="label-position"
                        outlined
                        v-on="on"
                      >
                        <template v-slot:prepend-inner>
                          <v-icon>
                            mdi-calendar
                          </v-icon>
                        </template>
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="effectiveDate"
                      @input="effectiveDateMenu = false"
                    />
                  </v-menu>
                  <p
                    v-if="$moment(effectiveDate).diff($moment()) >= 0"
                    class="warning--text"
                  >
                    By selecting a future date, the details will only save when it reach the date
                  </p>
                </v-col>

                <v-col
                  cols="12"
                  class="py-0"
                >
                  <v-radio-group
                    v-model="promotionDemotion"
                    v-validate="'required'"
                    :error-messages="errors.collect('promotionDemotion')"
                    data-vv-name="promotionDemotion"
                    data-vv-as="status"
                    label="Status"
                  >
                    <v-radio
                      label="Promotion"
                      value="promotion"
                    />
                    <v-radio
                      label="Demotion"
                      value="demotion"
                    />
                    <v-radio
                      label="Change Of Position"
                      value="change_of_position"
                    />
                    <v-radio
                      label="Change Of Company"
                      value="change_of_company"
                    />
                    <v-radio
                      label="Probation In New Position"
                      value="probation"
                    />
                    <v-radio
                      label="Others"
                      value="others"
                    />
                  </v-radio-group>
                </v-col>

                <v-col
                  v-if="promotionDemotion === 'others'"
                  cols="12"
                  class="pb-0"
                >
                  <v-text-field
                    v-model="remark"
                    v-validate="'required'"
                    label="Remark"
                    :error-messages="errors.collect('remark')"
                    data-vv-name="remark"
                  />
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="6">
              <v-row>
                <v-col
                  v-if="promotionDemotion === 'probation'"
                  cols="12"
                  class="pb-0"
                >
                  <v-menu
                    v-model="probationStartDateMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="probationStartDateDisplay"
                        v-validate="promotionDemotion ==='probation'?'required':''"
                        label="Probation Start Date"
                        outlined
                        :error-messages="errors.collect('probationStartDateDisplay')"
                        data-vv-name="probationStartDateDisplay"  
                        data-vv-as="probation start date"      
                        readonly
                        class="label-position"
                        v-on="on"
                      >
                        <template v-slot:prepend-inner>
                          <v-icon>
                            mdi-calendar
                          </v-icon>
                        </template>
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="probationStartDate"
                      :max="probationEndDate"
                      @input="probationStartDateMenu = false"
                    />
                  </v-menu>
                </v-col>

                <v-col
                  v-if="promotionDemotion === 'probation'"
                  cols="12"
                  class="pb-0"
                >
                  <v-menu
                    v-model="probationEndDateMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="probationEndDateDisplay"
                        v-validate="promotionDemotion ==='probation'?'required':''"
                        label="Probation End Date"
                        outlined
                        :error-messages="errors.collect('probationEndDateDisplay')"
                        data-vv-name="probationEndDateDisplay"  
                        data-vv-as="probation end date"      
                        readonly
                        class="label-position"
                        v-on="on"
                      >
                        <template v-slot:prepend-inner>
                          <v-icon>
                            mdi-calendar
                          </v-icon>
                        </template>
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="probationEndDate"
                      :min="probationStartDate"
                      @input="probationEndDateMenu = false"
                    />
                  </v-menu>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </form> 

      <v-card-actions v-if="dialog && !loading">
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Cancel
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"    
          class="white--text px-10"      
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions> 
    </material-card>  
  </v-dialog>
</template>

<script> 
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    components: {
      HelperFileInput: () => import('@/components/hris/helper/FileInput'),
    },    
    props: {
      employeeUid: {
        type: String,
        required: true,
      },
      position: {
        type: Object,
        default: null,
      },
    },
    data () {
      return {
        dialog: false,
        progressing: false,
        localPosition: null,
        file: null,
        positions: [],
        loading: false,
        effectiveDateMenu: null,
        effectiveDate: null,
        promotionDemotion: null,
        probationStartDate: null,
        probationStartDateMenu: false,
        probationEndDate: null,
        probationEndDateMenu: false,
        remark: null,
      }
    },
    computed: {
      effectiveDateDisplay () {
        return this.effectiveDate ? this.$moment(this.effectiveDate, 'YYYY-MM-DD').format('D MMM YYYY') : ''
      },
      probationStartDateDisplay () {
        return this.probationStartDate ? this.$moment(this.probationStartDate, 'YYYY-MM-DD').format('D MMM YYYY') : ''
      },
      probationEndDateDisplay () {
        return this.probationEndDate ? this.$moment(this.probationEndDate, 'YYYY-MM-DD').format('D MMM YYYY') : ''
      },       
    },
    watch: {
      dialog: function (value) {
        if (!value) return 

        this.loading = true

        this.localPosition = { ...this.position }
       
        this.$api.positions().list()
          .then(res => {
            this.positions = res.data.map(pos => ({
              id: pos.id,
              label: `${pos.name} (${pos.job_grade.name} ${pos.job_grade.job_group.name})`,
            }))

            this.loading = false
          })
      },
      promotionDemotion: {
        immediate: true,
        handler (value) {
          if (value) {
            this.probationStartDate = null
            this.probationEndDate = null
            this.effectiveDate = null
            this.remark = null
          }
        },
      },
    },
    methods: { 
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.setProgressing(true)

            this.$api.hrisEmployeePositions().create(this.employeeUid, this.prepareFormData())
              .then(res => {
                if (res.status === 200 || res.status === 201) {
                  this.$emit('updated')
                  this.$snack({ message: 'Employee position updated' })

                  this.setProgressing(false)
                  this.dialog = false
                }
              }).catch(error => {
                if (error.response.status === 405) {
                  this.$dialog({
                    title: 'Unable to change employee position',
                    message: error.response.data.status, 
                    color: 'error',
                  })
                }
                this.setProgressing(false)
              })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
      prepareFormData () {
        let takeEffectFrom = this.promotionDemotion === 'probation' ? this.probationStartDate : this.effectiveDate

        if (this.file) {
          this.file.formData.set('position_id', this.localPosition.id)
          this.file.formData.set('effective_date', takeEffectFrom)
          this.file.formData.set('promotion_demotion', this.promotionDemotion)
          this.file.formData.set('probation_start_date', this.probationStartDate)
          this.file.formData.set('probation_end_date', this.probationEndDate)
          if (this.remark) {
            this.file.formData.set('remark', this.remark)
          }

          return this.file.formData
        }

        let formData = new FormData()

        formData.append('position_id', this.localPosition.id)
        formData.append('effective_date', takeEffectFrom)
        formData.append('promotion_demotion', this.promotionDemotion)
        formData.append('probation_start_date', this.probationStartDate)
        formData.append('probation_end_date', this.probationEndDate)
        if (this.remark) {
          formData.append('remark', this.remark)
        }

        return formData
      },      
    },
  }
</script>

<style scoped>
.label-position >>> .v-label.v-label--active{
  margin-left:-28px;
  background:white;
  padding-right:1px
}
</style>
